import { jsonp } from '@ifeng-fe/ui_base';

const arr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

// 获取美国大选2020开票数据
export const getVotesData = async () => {
    const cache = new Date().getTime();

    const data = await jsonp('https://shankapi.ifeng.com/feedflow/usavote2024/info/getVotesData', {
        jsonpCallback: 'getVotesData',
        cache,
        timeout: 10000,
    });

    if (data.code === 0) {
        const all = data.data.data[0];

        if (!data.data.data[0].bidenNum) {
            data.data.data[0].bidenNum = all._bidenNum || 0;
        }

        if (!data.data.data[0].trumpNum) {
            data.data.data[0].trumpNum = all._trumpNum || 0;
        }

        if (!data.data.data[0].otherNum) {
            data.data.data[0].otherNum = all._otherNum || 0;
        }

        if (!data.data.data[0].bidenSum) {
            data.data.data[0].bidenSum = all._bidenSum || 0;
        }

        if (!data.data.data[0].trumpSum) {
            data.data.data[0].trumpSum = all._trumpSum || 0;
        }

        if (!data.data.data[0].otherSum) {
            data.data.data[0].otherSum = all._otherSum || 0;
        }

        // if (!data.data.data[0].bidenRate) {
        //     data.data.data[0].bidenRate = all._bidenRate || 0;
        // }

        // if (!data.data.data[0].trumpRate) {
        //     data.data.data[0].trumpRate = all._trumpRate || 0;
        // }

        // if (!data.data.data[0].otherRate) {
        //     data.data.data[0].otherRate = all._otherRate || 0;
        // }

        data.data.data = [
            data.data.data[0],
            ...data.data.data.slice(1).sort((a, b) => {
                if (arr.indexOf(a.id ? a.id.slice(0, 1) : 'Z') === arr.indexOf(b.id ? b.id.slice(0, 1) : 'Z')) {
                    return arr.indexOf(a.id ? a.id.slice(1) : 'Z') - arr.indexOf(b.id ? b.id.slice(1) : 'Z');
                }

                return arr.indexOf(a.id ? a.id.slice(0, 1) : 'Z') - arr.indexOf(b.id ? b.id.slice(0, 1) : 'Z');
            }),
        ];

        return data.data;
    }

    return {};
};

export const getQrcodeImage = async (url) => {
    const res = await jsonp('https://qrcode.ifeng.com/qrcode.php', {
        data: {
            url,
        },
        jsonpCallback: 'getQrcode',
        cache: false,
    });

    return res?.qrcode_url || '';
};
